import apiService from "./apiService";
import authService from "./authService";

const getUserNameIcon = () => {
  const userDetail =
    sessionStorage.getItem("userDetail") &&
    JSON.parse(authService.dec(sessionStorage.getItem("userDetail")));
  return userDetail?.userinfo?.name[0]?.toUpperCase() || "";
};

const userData = {
  userDetail:
    sessionStorage.getItem("userDetail") &&
    JSON.parse(authService.dec(sessionStorage.getItem("userDetail"))),

  get name() {
    return this.userDetail?.userinfo?.name;
  },

  get userid() {
    return this.userDetail?.userinfo?.userid;
  },

  get mercid() {
    return this.userDetail?.userinfo?.merc_id;
  },

  get isAdmin() {
    return Boolean(this.userDetail?.userinfo?.role?.toUpperCase() === "ADMIN");
  },

  get role() {
    return this.userDetail?.userinfo?.role;
  },

  get mobile() {
    return this.userDetail?.userinfo?.mobileno;
  },

  get email() {
    return this.userDetail?.userinfo?.mailid;
  },

  get sampleExcel() {
    return this.userDetail?.userinfo?.uploadformat;
  },
};

const getUserList = async () => {
  const apiData = {
    mercid: userService?.userData?.mercid,
    userid: userService?.userData?.userid,
    eventtype: "LISTING",
  };

  const response = await apiService.fetchData(apiData, "manageusers");

  return response;
};

const createNewUser = async (userData) => {
  const response = await apiService.fetchData();

  return response;
};

const userService = {
  userData: userData,
  getUserNameIcon: getUserNameIcon(),
  getUserList: () => getUserList(),
  createNewUser: (userData) => createNewUser(userData),
};

export default userService;
